<template>
	<div class="sidebar-promo">
		<div class="sidebar-promo-header" v-if="upgradeSolution">
			<p>Sign up today and get</p>
		</div><!-- end.sidebar-promo-header -->
		<div class="sidebar-promo-body" v-if="!solution">
			<img
				v-if="!solution"
				:src="`${assetBase}/assets/main/images/promo/package-modal-hero.png`"
				:srcset="`${assetBase}/assets/main/images/promo/package-modal-hero@2x.png 2x`"
				alt="">
		</div><!-- end.sidebar-promo-body -->
		<div class="sidebar-promo-body" v-if="solution && upgradeSolution">
			<div class="upgrade-solution-card">
				<div class="speeds">
					<dl>
						<dt><img :src="`${assetBase}/assets/main/images/promo/speed-down.png`"
								 :srcset="`${assetBase}/assets/main/images/promo/speed-down@2x.png 2x`"
								 alt=""></dt>
						<dd>{{ upgradeSolution.speed_down }}Mbps</dd>
					</dl>
					<dl>
						<dt><img :src="`${assetBase}/assets/main/images/promo/speed-up.png`"
								 :srcset="`${assetBase}/assets/main/images/promo/speed-up@2x.png 2x`"
								 alt=""></dt>
						<dd>{{ upgradeSolution.speed_up }}Mbps</dd>
					</dl>
				</div>
				<p>Speed Upgrade</p>
			</div><!-- end.upgrade-solution-card -->
		</div><!-- end.sidebar-promo-body -->
		<div class="sidebar-promo-body" v-if="solution && !upgradeSolution">
			<div class="upgrade-solution-card">
				<div class="speeds">
					<dl class="full">
						<dt><img
							:src="`${assetBase}/assets/main/images/promo/error.png`"
							:srcset="`${assetBase}/assets/main/images/promo/error@2x.png 2x`"
							alt=""></dt>
						<dd>This package does not qualify for the double speed promo</dd>
					</dl>
				</div>
			</div><!-- end.upgrade-solution-card -->
		</div><!-- end.sidebar-promo-body -->
	</div><!-- end.sidebar-promo -->
</template>

<script>
	export default {
		props: [
			'solution',
			'solutions'
		],
		computed: {
			assetBase() {
				return window._assetBaseUrl;
			},
			upgradeSolution() {

				// if(!this.solution) {
				// 	return false;
				// }

				// sort solutions bu download speed
				let solutions = this.solutions.sort((a, b) => {
					return (a.speed_down > b.speed_down) ? 1 : ((b.speed_down > a.speed_down) ? -1 : 0)
				});

				let symPackages = solutions.filter(a => a.speed_down === a.speed_up);
				let asymPackages = solutions.filter(a => a.speed_down !== a.speed_up);

				// exclude all Vuma Reach packages
				if(this.solution.provider_id === 24) {
					return false;
				}

				// exclude highest package
				let highestPackage = solutions[solutions.length-1];
				if(this.solution.solution_id === highestPackage.solution_id) {
					return false;
				}

				// exclude Evotel 200/200
				if(this.solution.solution_id === 1630820) {
					return false;
				}

				// Evotel 5/1
				if(this.solution.solution_id === 1682820) {
					return this.solutions.find(s => {
						return s.solution_id === 1581820;
					})
				}

				// Vuma 10/2
				if(this.solution.solution_id === 1626820) {
					return this.solutions.find(s => {
						return s.solution_id === 1518820;
					})
				}

				// Openserve 20/20
				if(this.solution.solution_id === 1524820) {
					return this.solutions.find(s => {
						return s.solution_id === 1525820;
					})
				}

				// symmetrical line speeds
				if(this.solution.speed_down === this.solution.speed_up) {
					// get the next symmetrical package
					let currentIndex = symPackages.indexOf(this.solution);
					return symPackages[currentIndex+1];
				}

				// asymmetrical line speeds
				if(this.solution.speed_down !== this.solution.speed_up) {
					// get the next asymmetrical package
					let currentIndex = asymPackages.indexOf(this.solution);
					return asymPackages[currentIndex+1];
				}

				return false;
			}
		}
	}
</script>
